// Small global footer — carries the public Privacy Policy link (required for the Connect IQ Store
// submission and generally good practice). Kept quiet and unobtrusive.
import { Box, Link, Typography, useTheme } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const Footer = () => {
  const theme = useTheme();
  const year = new Date().getFullYear();
  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 3,
        mt: 4,
        textAlign: "center",
        borderTop: `1px solid ${theme.palette.divider}`,
        color: theme.palette.text.secondary,
      }}
    >
      <Typography variant="body2" component="span">
        © {year} mkpace{" · "}
        <Link component={RouterLink} to="/privacy" color="inherit" underline="hover">
          Privacy Policy
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer;
